module.exports = __webpack_public_path__ + "static/check3-2841a0da10fc4018127d870cdaf23fc9.png";